import React from "react";

const Textarea = React.forwardRef(function Textarea(
  { className = "", rows = 3, ...props },
  ref,
) {
  const classes = [
    "w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 shadow-sm placeholder-gray-400 focus:border-gray-500 focus:outline-none focus:ring-1 focus:ring-gray-500 dark:border-gray-600 dark:bg-gray-800 dark:text-gray-100",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return <textarea ref={ref} rows={rows} className={classes} {...props} />;
});

export default Textarea;
